import { newsConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  },
  householdReadCount: {
    loading: false,
    data: null,
    fail: null
  },
  fileDownload: {
    loading: false
  }
};

export const news = (state = initalState, action) => {
  switch (action.type) {
    case newsConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case newsConstants.GET_ALL_SUCCESS:
      const { total, items, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          items
        }
      };
    case newsConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case newsConstants.GET_HOUSEHOLD_READ_COUNT_REQUEST:
      return {
        ...state,
        householdReadCount: {
          ...initalState.householdReadCount,
          loading: true
        }
      };
    case newsConstants.GET_HOUSEHOLD_READ_COUNT_SUCCESS:
      return {
        ...state,
        householdReadCount: {
          ...initalState.householdReadCount,
          loading: false,
          data: action.data
        }
      };
    case newsConstants.GET_HOUSEHOLD_READ_COUNT_FAILURE:
      return {
        ...state,
        householdReadCount: {
          ...initalState.householdReadCount,
          loading: false,
          fail: action.error
        }
      };
    case newsConstants.RESET_HOUSEHOLD_READ_COUNT_SUCCESS:
      return {
        ...state,
        householdReadCount: initalState.householdReadCount
      };
    case newsConstants.DOWNLOAD_NEWS_ATTACHMENT_REQUEST:
      return {
        ...state,
        fileDownload: {
          ...initalState.fileDownload,
          loading: true
        }
      };
    case newsConstants.DOWNLOAD_NEWS_ATTACHMENT_DOWN:
      return {
        ...state,
        fileDownload: initalState.fileDownload
      };
    case newsConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
